import { render, staticRenderFns } from "./productSale.vue?vue&type=template&id=cc676a20&scoped=true&"
import script from "./productSale.vue?vue&type=script&lang=js&"
export * from "./productSale.vue?vue&type=script&lang=js&"
import style0 from "./productSale.vue?vue&type=style&index=0&id=cc676a20&lang=scss&scoped=true&"
import style1 from "./productSale.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!///node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc676a20",
  null
  
)

export default component.exports